/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Title_LeadInputs */

const en_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Egly Method.`)
};

const es_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método Egly.`)
};

const de_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-Methode.`)
};

const zh_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method。`)
};

const ar_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منهج Egly.`)
};

const fr_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode Egly.`)
};

const vi_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương pháp Egly.`)
};

const sw_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mbinu ya Egly.`)
};

const th_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธี Egly`)
};

const bs_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly metoda.`)
};

const ja_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method。`)
};

const ko_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드.`)
};

const pt_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Método Egly.`)
};

const it_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Metodo Egly.`)
};

const sv_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const nl_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Egly Method.`)
};

const da_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const nb_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const fi_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const pl_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda Egly.`)
};

const ru_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метод Egly.`)
};

const tr_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const hi_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method।`)
};

const id_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const ms_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const cs_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method.`)
};

const el_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Μέθοδος Egly.`)
};

const he_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיטת Egly.`)
};

const af_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-metode.`)
};

const hu_method_title_lead = /** @type {(inputs: Method_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Egly Method.`)
};

/**
* | output |
* | --- |
* | "The Egly Method." |
*
* @param {Method_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_title_lead = /** @type {((inputs?: Method_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_title_lead(inputs)
	if (locale === "de") return de_method_title_lead(inputs)
	if (locale === "zh") return zh_method_title_lead(inputs)
	if (locale === "ar") return ar_method_title_lead(inputs)
	if (locale === "fr") return fr_method_title_lead(inputs)
	if (locale === "vi") return vi_method_title_lead(inputs)
	if (locale === "sw") return sw_method_title_lead(inputs)
	if (locale === "th") return th_method_title_lead(inputs)
	if (locale === "bs") return bs_method_title_lead(inputs)
	if (locale === "ja") return ja_method_title_lead(inputs)
	if (locale === "ko") return ko_method_title_lead(inputs)
	if (locale === "pt") return pt_method_title_lead(inputs)
	if (locale === "it") return it_method_title_lead(inputs)
	if (locale === "sv") return sv_method_title_lead(inputs)
	if (locale === "nl") return nl_method_title_lead(inputs)
	if (locale === "da") return da_method_title_lead(inputs)
	if (locale === "nb") return nb_method_title_lead(inputs)
	if (locale === "fi") return fi_method_title_lead(inputs)
	if (locale === "pl") return pl_method_title_lead(inputs)
	if (locale === "ru") return ru_method_title_lead(inputs)
	if (locale === "tr") return tr_method_title_lead(inputs)
	if (locale === "hi") return hi_method_title_lead(inputs)
	if (locale === "id") return id_method_title_lead(inputs)
	if (locale === "ms") return ms_method_title_lead(inputs)
	if (locale === "cs") return cs_method_title_lead(inputs)
	if (locale === "el") return el_method_title_lead(inputs)
	if (locale === "he") return he_method_title_lead(inputs)
	if (locale === "af") return af_method_title_lead(inputs)
	if (locale === "hu") return hu_method_title_lead(inputs)
	return en_method_title_lead(inputs)
});